module.exports = __webpack_public_path__ + "img/ios-tennisball.32a84626.svg";